import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { setSelectedItem } from 'app/actions/driver';
import { Autosizer, Image, Scrollbar } from 'app/components';
import { selectedItemSelector, sortItemsSelector } from 'app/selectors/driver';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';

const DriverList = function () {
  const dispatch = useDispatch();
  const selectedItem = useSelector(selectedItemSelector);

  const sortItems = useSelector(sortItemsSelector);

  const handleItemClick = (value) => dispatch(setSelectedItem(value));

  return (
    <Box
      component='div'
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        padding: theme.spacing(0),
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
        '.MuiListItem-root': {
          width: '100%',
          userSelect: 'none',
          padding: theme.spacing(0),
          borderRadius: '0',
          '.MuiListItemAvatar-root': {
            minWidth: '36px',
          },
          '.MuiAvatar-circular': {
            width: '24px',
            height: '24px',
          },
          '.MuiListItemButton-root': {
            padding: theme.spacing(1, 2),
            borderRadius: '0',
          },
          '.MuiListItemText-root': {
            margin: theme.spacing(0),
          },
        },
      })}>
      <Autosizer>
        {({ height, width }) => (
          <Box sx={{ height, width }}>
            <Scrollbar>
              {({ scrollableNodeRef, contentNodeRef }) => {
                return (
                  <FixedSizeList
                    height={height}
                    itemSize={36}
                    itemCount={sortItems.length}
                    innerRef={contentNodeRef}
                    outerRef={scrollableNodeRef}
                    innerElementType={driverListInnerElementType}
                    itemData={{
                      items: sortItems,
                      selectedItem,
                      onClick: handleItemClick,
                    }}>
                    {driverListItemRender}
                  </FixedSizeList>
                );
              }}
            </Scrollbar>
          </Box>
        )}
      </Autosizer>
    </Box>
  );
};

const driverListInnerElementType = forwardRef((props, ref) => <List ref={ref} disablePadding {...props} />);

const driverListItemRender = ({ data, index, style }) => {
  const { items, selectedItem, onClick } = data;

  return (
    <ListItem key={items[index].id} style={style} selected={items[index].id === selectedItem?.id} onClick={() => onClick(items[index])}>
      <ListItemButton>
        <ListItemAvatar>
          <Avatar>
            <Image name='avatar-driver.png' alt='avatar-driver.png' />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={items[index].name} />
      </ListItemButton>
    </ListItem>
  );
};

export default DriverList;
